import Api from '#services/api'

export function pending(state, payload) {
  return {
    ...state,
    isFetching: {
      ...state.isFetching,
      [payload.userId]: true,
    },
  }
}

export function fulfilled(state, payload, result) {
  return {
    users: {
      ...state.users,
      [payload.userId]: result,
    },
    isFetching: {
      ...state.isFetching,
      [payload.userId]: false,
    },
  }
}

export function rejected(state, payload) {
  return {
    ...state,
    isFetching: {
      ...state.isFetching,
      [payload.userId]: false,
    },
    users: {
      ...state.users,
      [payload.userId]: {
        id: payload.userId,
      },
    },
  }
}

export async function action(payload) {
  try {
    return await Api.getUserById(payload.userId)
  } catch (error) {
    throw new Error()
  }
}
